<template>

  <v-container class="my-5">
    <div class="form p-2 mt-5">
      <v-progress-linear class="my-3" color="primary" value="100"/>
      <h2>Thank You</h2>
      <p v-if="!isTeacher">Choose  Grade</p>
      <p v-else> What Grade Do you Teach?</p>
      <div class="inputs">
        <v-form>
          <v-select
              v-model="selectedGrade"
              :items="grades"
              :loading="loading"
              chips
              item-text="grade"
              item-value="id"
              label="Choose Grade"
          ></v-select>
        </v-form>
      </div>
      <v-row class="mt-6" justify="space-between">

        <v-btn
            :disabled="$v.$invalid || loading"
            color="primary"
            outlined
            small
            @click="handleClickBack()"
        >Back
        </v-btn
        >
        <v-btn
            :disabled="$v.$invalid || loading"
            :loading="loading"
            color="primary"
            small
            @click="handleSave()"
        >Save
        </v-btn
        >

        <v-btn
            :disabled="$v.$invalid || loading"
            color="primary"
            outlined
            small
            to="/"

        >Skip
        </v-btn
        >
      </v-row>

    </div>
  </v-container>
</template>

<script>
import Logo from "@/assets/guiomentorLogo.png";
import {mapGetters, mapMutations} from 'vuex';
import {required} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      Logo,
      loading: false,
      grades: [],
      selectedGrade: ""
    };
  },
  async mounted() {
    try {
      this.loading = true;
      const {data} = await this.axios.get(`/class_grade/?country_code=${this.user?.profile?.country?.toUpperCase()}`);
      this.grades = data.results;
    } catch (error) {
      const is404 = error?.response?.status === 404
      this.$snackbar.showMessage({
        color: is404 ? 'info' : "error",
        content: is404 ? 'We currently donot support your country' : "we couldnot retrieve grades"
      });
      if (is404) {
        await this.$router.push('/');
      }
    } finally {
      this.loading = false;
    }
  },
  methods: {
    ...mapMutations({
      setAuthSuccess: "auth/SET_AUTH_SUCCESS",
      setProfile: "auth/SET_USER_PROFILE"
    }),
    handleClickBack() {
      this.$emit('handleClickBack')
    },
    async handleSave() {
      try {
        this.loading = true;
        const {data: res} = await this.axios.patch(`/profile/update_profile/${this.user.id}/`, {
          grade_level: this.selectedGrade
        });
        this.$snackbar.showMessage({color: 'success', content: 'Grade level updated'})
        this.setAuthSuccess({...this.user, profile: {...this.user.profile, ...res}});
        this.setProfile({...this.profile, ...res});
        await this.$router.push('/');
      } catch (error) {
        this.$snackbar.showMessage({
          color: "error",
          content: error?.message || this.$t('errors.somethingWentWrongError'),
        });
      } finally {
        this.loading = false;
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "auth/GET_USER"
    }),
    isTeacher() {
      return this.user?.account_types[0]?.name === 'TEACHER'
    }
  },
  validations: {
    selectedGrade: {required}
  }
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";

.form {
  background: #ffffff;
  min-height: 700px;
  width: 90%;
  margin: 0 auto;
  border-radius: 20px;
  padding: 37px;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .form {
    width: 100%;
  }
}
</style>
